module.exports = __webpack_public_path__ + "img/67.bdbc0c00.png";